module.exports = __webpack_public_path__ + "img/zw-orders.6f3c36b5.svg";